import Mutations from '../../odata/mutations';

export default { ...new Mutations('event'), ...new Mutations('events') };
